import { SwiperSlide } from "swiper/react";

import React from "react";
import { Pagination } from "swiper/modules";
import { Navigation } from "swiper/modules";
import { Swiper } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Image from "next/image";
import SText from "@/components/atoms/SText";
import { IMAGE_WIDTH_EVENT_CARD } from "@/constants/number";
import { IMAGE_HEIGHT_EVENT_CARD } from "@/constants/number";
import SHeading from "@/components/atoms/SHeading";
type MachineCardProps = {
  scrImg: Record<string, string> | string;
  tag: React.ReactNode;
  stextHeading: string;
  describeText: string;
};
const MachineCard = (props: MachineCardProps) => {
  const { scrImg, tag, stextHeading, describeText } = props;
  return (
    <div className="min-h-[540px] w-auto flex flex-col justify-center items-center">
      {typeof scrImg === "object" ? (
        <Swiper
          modules={[Navigation, Pagination]}
          navigation
          pagination={{ clickable: true }}
          className="custom-swiper w-[360px] md:w-[390px] aspect-square custom-swiper-mobile max-h-[540px] md:h-[540px] h-[400px]"
        >
          {Object.entries(scrImg).map(([key, src]) => (
            <SwiperSlide key={key}>
              <Image
                src={src}
                unoptimized
                width={IMAGE_WIDTH_EVENT_CARD}
                height={IMAGE_HEIGHT_EVENT_CARD}
                alt={""}
                priority
                className=" max-h-[540px] w-[360px] object-cover md:w-[470px] md:h-[540px] h-[400px]"
              />
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <Image
          src={scrImg}
          unoptimized
          alt={""}
          width={IMAGE_WIDTH_EVENT_CARD}
          height={IMAGE_HEIGHT_EVENT_CARD}
          className=" max-h-[540px] w-[360px] object-cover md:w-[470px] md:h-[540px] h-[400px]"
        />
      )}
      <div className="flex mb-10 flex-col justify-center items-center">
        {tag && (
          <SText text={tag} className="italic text-center !text-rose mt-8" />
        )}
        <SHeading text={stextHeading} tAlign="center" />

        <p className="text-center lg:h-24 w-2/3 text-gray-500">
          {describeText}
        </p>
      </div>
    </div>
  );
};

export default MachineCard;
